module.exports = __webpack_public_path__ + "printer-link-icon.ceb8c8fea7ee9bffef52ac80115ad183.svg";